<template>
  <div class="timer">
    <span>{{ time.year }}</span>年
    <span>{{ time.month }}</span>月
    <span>{{ time.day }}</span>天
    <span class="time">{{ time.hour }} : {{ time.min }} : {{ time.sec }}</span>
  </div>
</template>
<script>
import { Tweenable } from 'shifty'
import { getLivesCountByYear, getBatteryPercent } from '../utils'
export default {
  name: 'Timer',
  props: ['date','maxLifeTime'],
  data () {
    return {
      time: {},
      isAnimated: false
    }
  },
  mounted () {
    setTimeout(()=>{
      this.counting()
      setInterval(this.counting, 1000)
    })
  },
  methods: {
    counting () {
      const {
        year,
        month,
        day,
        hour,
        minute,
        second
      } = getLivesCountByYear(this.date, this.maxLifeTime)

      this.time = Object.assign({}, this.time, {
        year,
        month,
        day,
        hour,
        min: minute,
        sec: second
      })

      this.$parent.batteryPercent = getBatteryPercent(year, this.maxLifeTime)
    },
    initAnimate () {
      if( this.isAnimated ) return
      const tweenable = new Tweenable()
      tweenable.tween({
        from: { year: this.maxLifeTime },
        to: { year: this.time.year },
        duration: 2000,
        easing: 'easeOutCubic',
        step: state => {
         this.time.year = parseInt(state.year)
        },
        start: () => {
          this.isAnimated = true
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
 .timer {
  justify-content: center;
  color: gray;

  span:not(:last-child) {
    // position: relative;
    // top: -4px;
    font-size:1.7rem;
    font-style: italic;
    margin: 0 5px;
    color:indianred;
  }
 } 
</style>